var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: _vm.$style.container },
    [
      !_vm.redirectTo
        ? _c(
            "ButtonLoginSwitch",
            { attrs: { clickHandler: _vm.goToAdminLogin } },
            [_vm._v("\n    Administrator Login\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.formContainer },
        [
          _vm.isIdentityFirstFlow
            ? _c(
                "UserLoginController",
                _vm._b(
                  { attrs: { goToAdminLogin: _vm.goToAdminLogin } },
                  "UserLoginController",
                  _vm.$props,
                  false
                )
              )
            : _c(
                "UserLoginForm",
                _vm._b(
                  {
                    attrs: {
                      autofocus: _vm.autofocus,
                      form: _vm.form,
                      goToAdminLogin: _vm.goToAdminLogin,
                      loadingErrorMsg: _vm.error,
                      loadingSuccessMsg: _vm.success,
                      updateAutofocus: _vm.updateAutofocus,
                    },
                  },
                  "UserLoginForm",
                  _vm.$props,
                  false
                )
              ),
          _vm._v(" "),
          _c("LogoIcon"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }